//#region  import
import React from "react"
import { createLseNewsHeadersData, createLseNewsRowData } from "../../components/layout/HomeTables/CreateLseNewsTableData"
import NumerableTable from "../../components/NumerableTable"
import { filterNewsByCheckbox } from "../../components/layout/FilterSearchResults"
import initStats from "../../components/layout/InitStats"
import NoDataMessage from "../../components/searchCompanies/NoDataMessage"
import { LAYOUT, } from "../../modules/constants"

import CircularProgress from '@mui/material/CircularProgress'
//#endregion import

export const NexusNews = props => {
  // console.log('NexusNews props:', props)
  const { checkboxes, hubData: { lseProps, lsePerson }, kind, newsMeta, portrait } = props
  const nexus = true

  const items = newsMeta
    ? lseProps // lseProps indicates Company. Otherwise, this is person news
      ? newsMeta.filter(n => n.lei === lseProps.lei)
      : newsMeta.filter(n => n.personIds.includes(props.entity.ids[0]))
    : []

  const filteredItems = lseProps // lseProps indicates Company. Otherwise, this is person news
    ? filterNewsByCheckbox({ checkboxes, items, nexus })
    : items

  const stats = initStats()

  const tableInfo = {
    page: 0,
    rowsPerPage: 999
  }

  const companyPaddingleft = lsePerson && portrait ? LAYOUT.HOME.PADDING.BORDER : 0

  return (
    <React.Fragment>
      {newsMeta && !filteredItems.length &&
        <NoDataMessage kind={kind} totalResults={items.length} />
      }
      {filteredItems?.length > 0 &&
        (<NumerableTable table={{
          ...props,
          headers: createLseNewsHeadersData({ ...props, companyPaddingleft, nexus }),
          rows: createLseNewsRowData({ ...props, companyPaddingleft, items: filteredItems, nexus, stats }),
          footers: null,
          handleOnClick: row => props.handleSelect(row),
          tableInfo,
        }}
        ></NumerableTable>)
      }

      {!newsMeta &&
        <CircularProgress
          style={{ position: "fixed", top: "calc(50% - 20px)", left: "calc(50% - 20px)", zIndex: 2 }}
        />}
    </React.Fragment>
  )
}
